import { useEffect, useState } from 'react'

export const mediaQuery = {
  sp: 'width < 752px',
  tablet: '752px <= width < 1122px',
  pc: '1122px <= width',
}

const isMobileDevice = () => {
  const userAgent = typeof navigator === "undefined" ? "" : navigator.userAgent.toLowerCase();
  // タブレットを除外し、電話系のみSP判定する
  return /iphone|ipod/.test(userAgent) || (/android/.test(userAgent) && /mobile/.test(userAgent));
};

export const useMediaQuery = (query) => {
  const formattedQuery = `(${query})`;
  const [match, setMatch] = useState(() => {
    const matches = matchMedia(formattedQuery).matches;
    if (query === mediaQuery.sp) {
      return matches || isMobileDevice();
    }
    return matches;
  });

  useEffect(() => {
    const mql = matchMedia(formattedQuery);

    if (mql.media === "not all" || mql.media === "invalid") {
      console.error(`useMediaQuery Error: Invalid media query`);
    }

    const handleChange = (e) => {
      if (query === mediaQuery.sp) {
        setMatch(e.matches || isMobileDevice());
      } else {
        setMatch(e.matches);
      }
    };

    mql.addEventListener("change", handleChange);
    return () => {
      mql.removeEventListener("change", handleChange);
    };
  }, [formattedQuery, query]);

  return match;
};

// export const useMediaQuery = (query) => {
//   const formattedQuery = `(${query})`
//   const [match, setMatch] = useState(matchMedia(formattedQuery).matches)

//   useEffect(() => {
//     const mql = matchMedia(formattedQuery)

//     if (mql.media === 'not all' || mql.media === 'invalid') {
//       console.error(`useMediaQuery Error: Invalid media query`)
//     }

//     mql.onchange = (e) => {
//       setMatch(e.matches)
//     }

//     return () => {
//       mql.onchange = null
//     }
//   }, [formattedQuery, setMatch])

//   return match
// }
